function getHostname(): string {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

export function isProdXandrEnv(hostname?: string): boolean {
  const host = hostname ?? getHostname();
  return host === 'monetize.xandr.com' || host === 'curate.xandr.com';
}

export function isStagingXandrEnv(hostname?: string): boolean {
  const host = hostname ?? getHostname();
  return host === 'staging.monetize.xandr.com' || host === 'staging.curate.xandr.com';
}

export function getBotMtApiUrl(hostname?: string): string {
  if (isProdXandrEnv(hostname)) {
    return 'https://copilot.api.ads.microsoft.com/api';
  }

  return 'https://copilot.api.sandbox.ads.microsoft.com/api';
}
